const OK_STATUSES = new Set([200, 201, 204]);

export class ApiRequestError extends Error {
  constructor(apiResponse, context) {
    super(`${context}: ${apiResponse?.cancelled ? 'cancelled' : 'non-2xx response'}`);
    this.name = 'ApiRequestError';
    this.apiResponse = apiResponse;
    this.cancelled = !!apiResponse?.cancelled;
  }
}

// El interceptor de axios no lanza en error HTTP: devuelve { error }. Sin esta guarda, un flujo con
// varias peticiones encadenadas sigue adelante y da el guardado por bueno.
export async function ensureOk(request, context) {
  const response = await request;

  // `cancelled` antes que el status: una respuesta cancelada no trae status y quien la reciba como
  // error acabaria anunciandola (openToastResponse mira `error`, que en ese caso es null).
  if (response?.cancelled) throw new ApiRequestError(response, context);

  if (!OK_STATUSES.has(response?.status)) throw new ApiRequestError(response, context);

  return response;
}
